
import moment from "moment";
export default class EquipeFFRValidator {
    reservation;
    equipes;
    courses;
    module;
    validation;
    validation_equipes;
    constructor(r, e, c, m) {
        // Constructor code here
        this.reservation = r;
        this.equipes = e;
        this.courses = c;
        this.module = m;
        this.validation = { status: false, details: [] };
        this.validation_equipes = [];
    }

    validate() {
        this.validation_equipes = [];
        // If there are no equipes, the validation is true
        if (!this.equipes || this.equipes.length == 0) {
            this.validation.status = true;
            this.validation.details = [];
            return this.validation;
        }

        for (let i = 0; i < this.equipes.length; i++) {
            let equipe = this.equipes[i];
            const validation_equipe = this.is_equipe_valid(equipe);
            this.validation_equipes.push(validation_equipe);
        }
        const global_status_validation = this.is_global_valid();
        this.validation.status = global_status_validation;
        this.validation.details = this.validation_equipes;

        return this.validation;
    }

    is_global_valid() {
        for (let i = 0; i < this.validation_equipes.length; i++) {
            if (!this.validation_equipes[i].status) return false;
        }
        return true;
    }



    is_equipe_valid(equipe) {

        let list_verification = [];
        const id_course = equipe.id_course;
        const course = this.courses.find(c => c.id == id_course);
        let equipe_validation = { equipe_name: equipe.nom, course_name: course.nom, status: true, errors: [] };
        const apply_rules_cdf_lc = course?.metadatas?.rules_cdf_longe_cote == "1";
        const apply_rules_open_lc = course?.metadatas?.rules_open_longe_cote == "1";
        const has_to_be_mixte = course?.metadatas?.obligatoire_mixte == "1";
        const contains_2_mens_2_womens = course?.metadatas?.contains_2_mens_2_womens == "1";

        if (apply_rules_cdf_lc) {
            const verify_rules_cdf_lc = this.is_equipe_cdf_lc_valide(equipe);
            list_verification.push(verify_rules_cdf_lc);
        }
        if (apply_rules_open_lc) {
            const verify_rules_open_lc = this.is_equipe_open_lc_valide(equipe);
            list_verification.push(verify_rules_open_lc);

        }
        if (has_to_be_mixte) {
            const verify_rules_mixte = this.is_equipe_mixte_valide(equipe);
            list_verification.push(verify_rules_mixte);
        }
        if (contains_2_mens_2_womens) {
            const verify_rules_2m2w = this.is_equipe_2m2w_valide(equipe);
            list_verification.push(verify_rules_2m2w);
        }
        for (let i = 0; i < list_verification.length; i++) {
            if (list_verification[i].error != "") {
                equipe_validation.errors.push(list_verification[i].error);
            }
            equipe_validation.status = equipe_validation.status && list_verification[i].status;
        }
        return equipe_validation;
    }

    is_equipe_mixte_valide(equipe) {
        let sexe_representes = [];
        for (let i = 0; i < equipe.coureurs.length; i++) {
            let coureur = this.reservation.inscriptions[equipe.coureurs[i].index].coureur;
            let sexe = coureur.get_field_value_by_name("sexe");
            if (!sexe_representes.includes(sexe)) {
                sexe_representes.push(sexe);
            }
        }
        if (sexe_representes.length == 1) {
            return { status: false, error: "Cette equipe doit être mixte." };
        }
        return { status: true, error: "" };
    }

    is_equipe_2m2w_valide(equipe) {
        let sexe_representes = [];
        for (let i = 0; i < equipe.coureurs.length; i++) {
            let coureur = this.reservation.inscriptions[equipe.coureurs[i].index].coureur;
            let sexe = coureur.get_field_value_by_name("sexe");
            sexe_representes.push(sexe);
        }
        const nb_men = sexe_representes.filter(s => s == "M").length;
        const nb_women = sexe_representes.filter(s => s == "F").length;
        if (nb_men == 2 && nb_women == 2) {
            return { status: true, error: "" };
        }
        return { status: false, error: "Cette equipe doit contenir 2 hommes et 2 femmes." };
    }


    is_equipe_cdf_lc_valide(equipe) {
        let categories_representes = [];
        for (let i = 0; i < equipe.coureurs.length; i++) {
            let coureur = this.reservation.inscriptions[equipe.coureurs[i].index].coureur;
            let date_naissance = coureur.get_field_value_by_name("date_naissance");
            let categorie = this.get_categorie_by_naissance(date_naissance);
            categories_representes.push(categorie);
        }
        const verify_supra_categorie_senior = this.is_supra_categorie_senior(categories_representes);
        const verify_supra_categorie_master = this.is_supra_categorie_master(categories_representes);
        if (verify_supra_categorie_master.status || verify_supra_categorie_senior.status) {
            return { status: true, error: "" };
        }
        let errors = [];
        if (!verify_supra_categorie_master.status) errors.push(verify_supra_categorie_master.error);
        if (!verify_supra_categorie_senior.status) errors.push(verify_supra_categorie_senior.error);
        return { status: false, error: errors.join(" OU ") };
    }


    // Tous les coureurs doivent entre entre juniors et M2, et au moins deux categories doivent être représentées
    is_supra_categorie_senior(categories_representes) {
        let allowed_categories = ["Juniors", "Seniors", "Masters 1", "Masters 2"];
        let different_categories = [];
        for (let i = 0; i < categories_representes.length; i++) {
            if (!allowed_categories.includes(categories_representes[i])) {
                return { status: false, error: "Si Supra-Catégorie Senior : Un participant en " + categories_representes[i] + " ne peut pas faire parti de l'équipe." };
            }
            if (!different_categories.includes(categories_representes[i])) different_categories.push(categories_representes[i]);
        }

        return { status: true, error: "" };

    }

    // Tous les coureurs doivent entre entre M2 et M4, et au moins deux categories doivent être représentées
    is_supra_categorie_master(categories_representes) {
        let allowed_categories = ["Masters 2", "Masters 3", "Masters 4"];
        let different_categories = [];
        for (let i = 0; i < categories_representes.length; i++) {
            if (!allowed_categories.includes(categories_representes[i])) return { status: false, error: "Si Supra-Catégorie Master: Un participant en " + categories_representes[i] + " ne peut pas faire parti de l'équipe." };
            if (!different_categories.includes(categories_representes[i])) different_categories.push(categories_representes[i]);
        }
        let has_m3_or_m4 = different_categories.includes("Masters 3") || different_categories.includes("Masters 4");
        if (has_m3_or_m4) {
            return { status: true, error: "" };
        }
        else {
            return { status: false, error: "Si Supra-Catégorie Master: Il faut au moins une de ces catégories (Masters 3/Masters 4)." };
        }
        return { status: true, error: "" };
    }



    is_equipe_open_lc_valide(equipe) {
        let categories_representes = [];
        for (let i = 0; i < equipe.coureurs.length; i++) {
            let coureur = this.reservation.inscriptions[equipe.coureurs[i].index].coureur;
            let date_naissance = coureur.get_field_value_by_name("date_naissance");
            let categorie = this.get_categorie_by_naissance(date_naissance);
            categories_representes.push(categorie);
        }
        const verify_cadets = this.check_cadets_valide(categories_representes);
        const verify_juniors = this.check_juniors_valide(categories_representes);
        if (verify_cadets.status && verify_juniors.status) {
            return { status: true, error: "" };
        }
        let errors = [];
        if (!verify_cadets.status) errors.push(verify_cadets.error);
        if (!verify_juniors.status) errors.push(verify_juniors.error);
        return { status: false, error: errors.join(" OU ") };
    }

    check_cadets_valide(categories_representes) {
        const nb_cadets = categories_representes.filter(c => c == "Minimes/Cadets").length;
        if (nb_cadets > 0 && nb_cadets < categories_representes.length) {
            return { status: false, error: "Un Minime/Cadet ne peut participer qu'avec un Minime/Cadet." };
        }
        return { status: true, error: "" };
    }

    check_juniors_valide(categories_representes) {
        const nb_juniors = categories_representes.filter(c => c == "Juniors").length;
        if (nb_juniors > 0) {
            const has_other_categories = categories_representes.filter(c => c != "Juniors" && c != 'Seniors').length > 0;
            if (has_other_categories) {
                return { status: false, error: "Un Junior ne peut participer que dans une équipe de Juniors ou de Seniors." };
            }
        }
        return { status: true, error: "" };
    }

    /*     is_equipe_binome_valide(equipe) {
            let categories_representes = [];
            for (let i = 0; i < equipe.coureurs.length; i++) {
                let coureur = this.reservation.inscriptions[equipe.coureurs[i].index].coureur;
                let date_naissance = coureur.get_field_value_by_name("date_naissance");
                let categorie = this.get_categorie_by_naissance(date_naissance);
                categories_representes.push(categorie);
            }
    
            // Verifications a effectuées
            // Un Minime/Cadet ne peut pas être associé à une autre catégorie que Minime/Cadet
            const nb_cadets = categories_representes.filter(c => c == "Minimes/Cadets").length;
            if (nb_cadets == 1) return [{ status: false, error: "Un Minime/Cadet ne peut participer qu'avec un Minime/Cadet." }];
            return [{ status: true, error: "" }];
    
        } */

    /*     is_equipe_tierce_valide(equipe) {
            let categories_representes = [];
            let sexe_representes = [];
            for (let i = 0; i < equipe.coureurs.length; i++) {
                let coureur = this.reservation.inscriptions[equipe.coureurs[i].index].coureur;
                let date_naissance = coureur.get_field_value_by_name("date_naissance");
                let sexe = coureur.get_field_value_by_name("sexe");
                let categorie = this.get_categorie_by_naissance(date_naissance);
                categories_representes.push(categorie);
                if (!sexe_representes.includes(sexe)) {
    
                    sexe_representes.push(sexe);
                }
            }
    
            if (sexe_representes.length > 1) {
    
                return [{ status: false, error: "Cette equipe ne peut pas être mixte." }];
            }
    
            // Verifications a effectuées
            const verify_supra_categorie_jeune = this.is_supra_categorie_jeune(categories_representes);
            const verify_supra_categorie_master = this.is_supra_categorie_master(categories_representes);
            return [verify_supra_categorie_jeune, verify_supra_categorie_master];
    
        } */







    get_categorie_by_naissance(date_naissance) {
        let annee_naissance = moment(date_naissance).year();
        if (!annee_naissance) return "-";

        // Récupérer la date de l'événement depuis le module
        let date_evenement = null;
        if (this.module && this.module.evenement) {
            date_evenement = this.module.evenement.date_debut;
        }

        // Calculer l'âge
        let age = moment().year() - annee_naissance;

        // Si l'événement est après septembre, ajouter +1 à l'âge
        if (date_evenement) {
            let mois_evenement = moment(date_evenement).month() + 1; // moment.month() retourne 0-11
            if (mois_evenement > 9) { // Après septembre (mois > 9)
                age += 1;
            }
        }

        if (age >= 12 && age <= 15) return "Minimes/Cadets";
        if (age >= 16 && age <= 17) return "Juniors";
        if (age >= 18 && age <= 39) return "Seniors";
        if (age >= 40 && age <= 49) return "Masters 1";
        if (age >= 50 && age <= 59) return "Masters 2";
        if (age >= 60 && age <= 69) return "Masters 3";
        if (age >= 70) return "Masters 4";
        return "-";
    }






}
